import React from 'react';

export default function AvisoPrivacidadMexico({
  emailContacto,
  webUrl,
  razonSocial,
  domicilio,
  arcoNombre,
  arcoDomicilio,
  arcoEmail,
  arcoTelefono,
  fechaUltimaActualizacion,
}) {
  const urlDisplay = webUrl
    ? webUrl.startsWith('http')
      ? webUrl.replace(/^https?:\/\//, '')
      : webUrl
    : null;
  const dominioRef = webUrl
    ? webUrl.startsWith('http')
      ? webUrl.replace(/^https?:\/\//, '')
      : webUrl
    : null;

  const hasIntroData = razonSocial || domicilio || urlDisplay;
  if (!hasIntroData) {
    return null;
  }

  const introParts = [];
  if (razonSocial) {
    introParts.push(`${razonSocial}, en lo sucesivo (GEA)`);
  } else {
    introParts.push('en lo sucesivo (GEA)');
  }
  if (domicilio) {
    introParts.push(`con domicilio en ${domicilio}`);
  }
  if (urlDisplay) {
    introParts.push(`con portal de internet ${urlDisplay}`);
  }
  const introText = introParts.join(', ') + ', es el responsable del uso y protección de sus datos personales, según lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de los Particulares y al respecto le informamos lo siguiente:';

  const hasArcoData = arcoNombre || arcoDomicilio || arcoEmail || arcoTelefono;

  return (
    <div className='space-y-4 text-sm text-gray-400 text-justify'>
      <h3 className='text-xl text-black font-bold mb-4 underline'>
        AVISO DE PRIVACIDAD INTEGRAL
      </h3>
      <p>{introText}</p>

      <h4 className='text-lg text-black font-bold mt-6'>FINALIDADES DEL TRATAMIENTO</h4>
      <p>
        Los datos personales que recabamos serán utilizados para las siguientes finalidades primarias:
      </p>
      <ul className='list-disc pl-6 space-y-2'>
        <li>Establecer contacto con usted a solicitud expresa mediante los formularios del sitio web.</li>
        <li>Brindarle información relacionada con paquetes turísticos, servicios de viaje o promociones publicadas en el sitio.</li>
        <li>Canalizar su solicitud hacia alguna de nuestras agencias afiliadas, cuando aplique.</li>
      </ul>
      <p>Por lo que dichas finalidades son necesarias e indispensables para el servicio que solicita.</p>

      <p className='font-semibold'>Finalidades secundarias (opcional):</p>
      <ul className='list-disc pl-6 space-y-2'>
        <li>Envío de boletines informativos o promociones, previo consentimiento.</li>
        <li>Realizar encuestas de satisfacción para mejorar nuestros servicios.</li>
      </ul>
      {emailContacto && (
        <p>
          En caso de que no desee que sus datos sean tratados para finalidades secundarias, puede manifestarlo desde este momento al correo: {emailContacto}
        </p>
      )}

      <h4 className='text-lg text-black font-bold mt-6'>DATOS PERSONALES RECABADOS:</h4>
      {dominioRef ? (
        <p>Los datos que podemos recabar a través de nuestro sitio web {dominioRef} son:</p>
      ) : (
        <p>Los datos que podemos recabar a través de nuestro sitio web son:</p>
      )}
      <ul className='list-disc pl-6 space-y-2'>
        <li>Nombre completo</li>
        <li>Correo electrónico</li>
        <li>Número telefónico (fijo o móvil)</li>
      </ul>
      <p>*No se recaban datos personales sensibles.</p>

      <h4 className='text-lg text-black font-bold mt-6'>TRANSFERENCIAS DE DATOS PERSONALES</h4>
      <p>
        GEA podrá transferir sus datos personales a agencias de viajes afiliadas, únicamente con el propósito de dar seguimiento a su solicitud de información o cotización.
      </p>
      <p>
        Estas transferencias no requieren su consentimiento en términos del artículo 37 de la LFPDPPP, ya que son necesarias para el cumplimiento de la relación comercial o precontractual con usted.
      </p>
      <p>*GEA no vende ni cede sus datos personales a terceros no relacionados.</p>

      <h4 className='text-lg text-black font-bold mt-6'>DERECHOS ARCO Y MECANISMOS PARA EJERCERLOS</h4>
      <p>
        Usted tiene derecho a conocer qué datos personales tenemos de usted, para qué los utilizamos y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en caso de que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros registros o bases de datos cuando considere que la misma no está siendo utilizada adecuadamente (Cancelación); así como oponerse al uso de sus datos personales para fines específicos (Oposición). Estos derechos se conocen como derechos ARCO.
      </p>
      {emailContacto && (
        <p>
          Para conocer el procedimiento y requisitos para el ejercicio de los derechos ARCO, le solicitamos nos requiera dicha información a través del envío de un correo electrónico al siguiente email: {emailContacto}
        </p>
      )}
      <p>Adjuntando la siguiente información:</p>
      <ul className='list-disc pl-6 space-y-2'>
        <li>Nombre del titular</li>
        <li>Descripción clara de los datos respecto de los cuales desea ejercer su derecho</li>
        <li>Medio para comunicarle la respuesta (correo electrónico)</li>
        <li>Documentación que acredite su identidad (INE o similar)</li>
      </ul>
      <p>*Le responderemos en un plazo máximo de 3 días hábiles.</p>

      {hasArcoData && (
        <>
          <p>Los datos de contacto de la persona que está a cargo de dar trámite a las solicitudes de derechos ARCO, son los siguientes:</p>
          <ul className='list-none pl-0 space-y-1'>
            {arcoNombre && <li>a) Nombre: {arcoNombre}</li>}
            {arcoDomicilio && <li>b) Domicilio: {arcoDomicilio}</li>}
            {arcoEmail && <li>c) Correo electrónico: {arcoEmail}</li>}
            {arcoTelefono && <li>d) Número telefónico: {arcoTelefono}</li>}
          </ul>
        </>
      )}

      <h4 className='text-lg text-black font-bold mt-6'>
        REVOCACIÓN DE CONSENTIMIENTO PARA EL USO DE SUS DATOS PERSONALES
      </h4>
      <p>
        Usted puede revocar el consentimiento que, en su caso, nos haya otorgado para el tratamiento de sus datos personales. Sin embargo, es importante que tenga en cuenta que no en todos los casos podremos atender su solicitud o concluir el uso de forma inmediata, ya que es posible que por alguna obligación legal requiramos seguir tratando sus datos personales. Asimismo, usted deberá considerar que, para ciertos fines, la revocación de su consentimiento implicará que no le podamos seguir prestando el servicio que nos solicitó, o la conclusión de su relación con nosotros.
      </p>
      {emailContacto && (
        <p>
          Para conocer el procedimiento y requisitos para la revocación del consentimiento, ponemos a su disposición el siguiente correo electrónico: {emailContacto}
        </p>
      )}

      <h4 className='text-lg text-black font-bold mt-6'>LÍMITE DE USO O DIVULGACIÓN DE LA INFORMACIÓN PERSONAL</h4>
      {emailContacto && (
        <p>
          Con objeto de que usted pueda limitar el uso y divulgación de su información personal, le ofrecemos el siguiente correo electrónico para realizar dicha solicitud: {emailContacto}
        </p>
      )}

      <h4 className='text-lg text-black font-bold mt-6'>CAMBIOS EN EL AVISO DE PRIVACIDAD</h4>
      <p>
        El presente aviso de privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos requerimientos legales; de nuestras propias necesidades por los productos o servicios que ofrecemos; de nuestras prácticas de privacidad; de cambios en nuestro modelo de negocio, o por otras causas.
      </p>
      {(emailContacto || urlDisplay) && (
        <p>
          Nos comprometemos a mantenerlo informado sobre los cambios que pueda sufrir el presente aviso de privacidad, a través de{' '}
          {emailContacto && urlDisplay && (
            <>un correo electrónico de la cuenta: {emailContacto} el cual será remitido a su email proporcionado, o bien por un aviso de dicha modificación en el portal de internet: {urlDisplay}</>
          )}
          {emailContacto && !urlDisplay && (
            <>un correo electrónico de la cuenta: {emailContacto} el cual será remitido a su email proporcionado</>
          )}
          {!emailContacto && urlDisplay && (
            <>un aviso de dicha modificación en el portal de internet: {urlDisplay}</>
          )}
          .
        </p>
      )}
      <p>
        El procedimiento a través del cual se llevarán a cabo las notificaciones sobre cambios o actualizaciones al presente aviso de privacidad es el siguiente:
      </p>
      <p>
        Los titulares de los datos personales podrán en todo momento consultar la página de internet: {webUrl ? (webUrl.startsWith('http') ? webUrl : `https://${webUrl}`) : ''} en donde se publicará cualquier modificación al aviso de privacidad.
      </p>
      <p>*Fecha de última actualización: {fechaUltimaActualizacion || '11 de Febrero de 2026'}</p>

      <h4 className='text-lg text-black font-bold mt-6'>USO DE COOKIES Y TECNOLOGÍAS SIMILARES</h4>
      <p>
        Nuestro sitio web puede utilizar cookies y otras tecnologías a fin de mejorar la experiencia del usuario. Usted puede deshabilitar el uso de cookies desde la configuración de su navegador.
      </p>
    </div>
  );
}
